module.exports = __webpack_public_path__ + "static/img/fot3.5e3cc9b7.png";